// extracted by mini-css-extract-plugin
export default {"orderContainer":"Order_orderContainer__8WavH","title":"Order_title__Wh0-Z"};